import {defineStore} from "pinia";

export const useThemeStore = defineStore({
    id: 'theme',
    state: () => {
        return {
            theme: "light" as string
        }
    },
    actions: {
        initTheme(): void {
            const localStorageTheme: string|null = localStorage.getItem('theme')
            if(localStorageTheme){
                this.theme = localStorageTheme
            }else{
                if(window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches)
                {
                    this.theme = 'dark'
                }else{
                    this.theme = 'light'
                }
            }

            this.toggleClass()
        },
        toggleTheme(): void {
            if(this.getTheme === 'light'){
                localStorage.setItem('theme', 'dark')
                this.theme = 'dark'
            } else {
                localStorage.setItem('theme', 'light')
                this.theme = 'light'
            }

            this.toggleClass()
        },
        toggleClass(): void {
            if(this.theme === 'dark'){
                document.querySelector("html")?.classList.add("theme-dark")
            }else {
                document.querySelector("html")?.classList.remove("theme-dark")
            }
        }
    },
    getters: {
        getTheme(): string{
            return this.theme
        }
    }
})
